import Avatar from './Avatar';
import Base from '../base';

/* istanbul ignore next */
Avatar.install = function (Vue) {
  Vue.use(Base);
  Vue.component(Avatar.name, Avatar);
};

export default Avatar;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_ant-design-vue@1.7.8@ant-design-vue/es/avatar/index.js
// module id = null
// module chunks = 